import { createSelector } from '@app/utils/createSelector'
import { catchFetchDataError } from '@app/utils/performFetchData'

import { getIdentities } from '@app/packages/api/v2/actions/identities'
import type { ApiSocialIdentity } from '@app/packages/api/v2/types/entities'
import { createPromise } from '@app/packages/thunkSelector/promiseState'
import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'

import { callV2Api } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'
import { createThunk } from '@app/store/thunk'

import { profileUserResultSelector } from './profile'

const socialIdentitiesSlice = createReduxSlice<{ user_id: string }>('social_identities')
const socialIdentitiesListSlice = createReduxSlice<ApiSocialIdentity[]>('social_identities_list')

export const fetchSocialIdentities = () =>
  createThunk(async dispatch => {
    const resp = await dispatch(callV2Api(getIdentities())).catch(catchFetchDataError(dispatch, 'Social identities fetch failed'))
    dispatch(socialIdentitiesListSlice.set(resp.data))
  })

export const socialIdentitiesResultSelector = createSelector(
  [socialIdentitiesSlice.selector, profileUserResultSelector, socialIdentitiesListSlice.selector],
  (meta, userResult, socialIdentities) =>
    createLoadable(c => {
      const user = c.unwrap(userResult)
      if (!user || user.account_type === 'visitor') return null
      if (!meta || user.id !== meta.user_id)
        return c.load(
          createPromise('Social identities must be fetched', user.id, async dispatch => {
            await dispatch(fetchSocialIdentities())
            dispatch(socialIdentitiesSlice.set({ user_id: user.id }))
          })
        )
      if (!socialIdentities) throw new Error('Social identities are missing')
      return socialIdentities
    })
)
